// src/app/logger/logger.component.ts
import { Component, HostListener, OnInit, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { ILogger } from './logger.interface';
import { LoggerService } from './logger.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChangeLogComponent } from './change-log/change-log.component';
import { LoggerActions } from './logger.constants';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { CompanyRoleLabels } from '../../users-page/users/users.constants';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { AuthService } from '../../../shared/services/auth.service';
import { DialogService } from '../../../shared/services/dialog/dialog.service';

let self: any;

@Component({
  selector: 'app-logger',
  templateUrl: './logger.component.html',
  styleUrls: ['./logger.component.css']
})
export class LoggerComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
  }
  screenWidth: number;
  logs: ILogger[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    filters: {},
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  roleLabels: any = CompanyRoleLabels;
  roleLabelsKeys = Object.keys(this.roleLabels);
  actionLabels: any = LoggerActions;
  actionLabelsKeys = Object.keys(this.actionLabels);
  isManax: boolean = false;
  isAdmin: boolean = false;
  constructor(
    private _loggerService: LoggerService,
    private _broadcaster: Broadcaster,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
  ) {
    self = this;
    this.screenWidth = window.innerWidth;
    this.registerStringBroadcast();
    this.registerQueryParamChanges();
  }

  registerQueryParamChanges() {
    this.querySubscription = this._route.queryParams.subscribe(params => {

    })
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.filters.roles = 'admin';
    this.getlogger(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      if (tmp == this.lazySearchTmp) {
        this.getlogger(true);
      }
    }, 1000);
  }

  getlogger(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.logs = [];
    }
    this._loggerService.getLogger(this.filter).subscribe((logger: any) => {

      /* REFACTOR */
      if (this.isAdmin && !this.isDev && !this.isManax) {
        logger = logger.filter((log: ILogger) => {
          return (log.user.roles.filter((rol: any) => (rol.name == 'manax' || rol.name == 'dev')).length) ? false : true;
        })
      }
      /* REFACTOR */

      this.logs = _.concat(this.logs, logger);
      const filter: any = this.filter;
      this.thereAreMore = logger.length >= filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getlogger();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }

  clearFilter() {
    this.filter.filters = {};
    this.getlogger(true);
  }

  sortLogger(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getlogger(true);
  }

  openChangeLogModal(log: any) {
    if (log.changes) {
      const index = this.logs.indexOf(log);
      let config = new MatDialogConfig();
      config.width = '1200px';
      config.maxWidth = '90vw';
      config.viewContainerRef = this._viewContainerRef;
      self.dialogRef = this._dialog.open(ChangeLogComponent, config);
      self.dialogRef.componentInstance.log = log;
      self.dialogRef.componentInstance.logIndex = index;
      self.dialogRef.componentInstance.totalLogs = this.logs.length;

      self.dialogRef.componentInstance.navigate = (step: number) => {
        const newIndex = self.dialogRef.componentInstance.logIndex + step;
        if (newIndex >= 0 && newIndex < this.logs.length) {
          self.dialogRef.componentInstance.log = this.logs[newIndex];
          self.dialogRef.componentInstance.logIndex = newIndex;
          self.dialogRef.componentInstance.updateLogDetails();
        }
      };

      self.dialogRef.afterClosed().subscribe((result: any) => {
        self.dialogRef = null;
      });
    }
  }

  isGreaterThan672px(): boolean {
    return this.screenWidth > 672;
  }
}
